import React, { useEffect } from 'react';
import './App.css';
// import { signOut } from "../auth/signOut";
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

  export  const Deconnexion = (props) => {

    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const isLegacy = searchParams.get('legacy') === 'true';

    // On supprime les données de connexion dans le local storage
    useEffect(() => {
        localStorage.removeItem('uid');
        localStorage.removeItem('expirationDate');
        localStorage.removeItem('client_type');
        localStorage.removeItem('encrypted_a');
        localStorage.removeItem('encrypted_b');
        // localStorage.removeItem('name');
        // localStorage.removeItem('email');
      }, []);

     /* const logout = async () => {
        try {
            await signOut();
        } catch (e) {
            alert(e.message);
        }
    } */

    // logout();


        return(
            <div className="PhraseDisconnect">

               {isLegacy && (
                <p>
                  Vous tentez de vous connecter avec l'ancienne méthode, depuis le 4 avril à 20h : vos liens de connexion enregistrés en favoris ne fonctionnent plus. Reconnectez-vous avec votre e-mail et mot de passe.{' '}
                  <a href="https://elyote.crunch.help/fr/simply-copy/creer-son-lien-de-connexion-a-simply-copy" target="_blank" rel="noopener noreferrer">
                    En savoir plus →
                  </a>
                </p>
               )}

               {props.errorMessage
                ? <p>
                    {t('logout.error_id')}
                </p>
                : null}
                {!isLegacy && (
                  <p>{t('logout.message')}
                  {/* {' '} <a href="https://bv.elyote.com">{t('logout.link_message')}</a> */}
                  </p>
                )}
          </div>)
          
         
       
    
 


}

